import { createSlice } from '@reduxjs/toolkit';
import apiURl from 'url';

const initialState = {
  settings: null,
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    setModuleSettings(state, action) {
      state.settings = action.payload;
    },
    setModuleStatus(state, action) {
      state.status = action.payload;
    },
    setModuleError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setModuleSettings, setModuleStatus, setModuleError } = moduleSlice.actions;

export const fetchModules = () => async (dispatch) => {
  dispatch(setModuleStatus('loading'));
  try {
    const response = await fetch(`${apiURl}/api/modules`);
    const json = await response.json();
    if (response.status === 200) {
      dispatch(setModuleSettings(json));
      dispatch(setModuleStatus('succeeded'));
    } else {
      dispatch(setModuleError('Failed to fetch modules'));
      dispatch(setModuleStatus('failed'));
    }
  } catch (err) {
    dispatch(setModuleError(err.message));
    dispatch(setModuleStatus('failed'));
  }
};

const moduleReducer = moduleSlice.reducer;
export default moduleReducer;
